import { render, staticRenderFns } from "./EducationSettings.vue?vue&type=template&id=6a0e866a&scoped=true&"
import script from "./EducationSettings.vue?vue&type=script&lang=js&"
export * from "./EducationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e866a",
  null
  
)

export default component.exports